// src/api/departmentApi.ts
import api from './api';

export interface Department {
  id?: number;
  name: string;
  description: string;
  is_active?: boolean;
}

const departmentApi = {
  // Add Department
  addDepartment: async (departmentData: Omit<Department, 'id'>) => {
    try {
      const response = await api.post('/add_department', departmentData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get All Departments
  getDepartments: async () => {
    try {
      const response = await api.get('/get_departments');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get Department By Id
  getDepartmentById: async (departmentId: number) => {
    try {
      const response = await api.get(`/get_department/${departmentId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Update Department
  updateDepartment: async (departmentId: number, departmentData: Partial<Department>) => {
    try {
      const response = await api.put(`/update_department/${departmentId}`, departmentData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Delete Department
  deleteDepartment: async (departmentId: number) => {
    try {
      const response = await api.delete(`/delete_department/${departmentId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default departmentApi;